/*****************************************************************************
 * Open MCT Web, Copyright (c) 2014-2015, United States Government
 * as represented by the Administrator of the National Aeronautics and Space
 * Administration. All rights reserved.
 *
 * Open MCT Web is licensed under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0.
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations
 * under the License.
 *
 * Open MCT Web includes source code licensed under additional open source
 * licenses. See the Open Source Licenses file (LICENSES.md) included with
 * this source code distribution or the Licensing information page available
 * at runtime from the About dialog for additional information.
 *****************************************************************************/

define('platform/features/conductor/core/src/ui/ConductorAxisDirective',['./ConductorAxisController'], function (ConductorAxisController) {
    function ConductorAxisDirective() {
        /**
         * The mct-conductor-axis renders a horizontal axis with regular
         * labelled 'ticks'. It requires 'start' and 'end' integer values to
         * be specified as attributes.
         */
        return {
            controller: [
                'openmct',
                'formatService',
                '$scope',
                '$element',
                ConductorAxisController
            ],
            controllerAs: 'axis',
            scope: {
                viewService: "="
            },
            bindToController: true,

            restrict: 'E',
            priority: 1000,

            template: '<div class="l-axis-holder" ' +
            '    mct-drag-down="axis.panStart()"' +
            '    mct-drag-up="axis.panStop(delta)"' +
            '    mct-drag="axis.pan(delta)"' +
            '    mct-resize="axis.resize()"></div>'
        };
    }

    return ConductorAxisDirective;
});

